export default "__VITE_ASSET__iFr4SZpm__"